import { createAsyncThunk } from '@reduxjs/toolkit';
import { axiosPrivate } from 'modules/networkTools/networkTools';

import type { DropdownOption, FetchDropdownOptionsArgs } from './types';

import { buildDropdownOptionsRequestMeta } from './dropdownOptionsUtils';

type DropdownOptionsApiItem = {
  id: string | number;
  name: string;
};

const DEFAULT_DROPDOWN_SEARCH_PARAM = 'search';

export type FetchDropdownOptionsResult = {
  cacheKey: string;
  items: DropdownOption[];
};

export const fetchDropdownOptions = createAsyncThunk(
  'dropdownOptions/fetchDropdownOptions',
  async (args: FetchDropdownOptionsArgs, { rejectWithValue }) => {
    try {
      const requestMeta = buildDropdownOptionsRequestMeta(args);
      const searchParams = new URLSearchParams();
      const searchParam = requestMeta.source.searchParam || DEFAULT_DROPDOWN_SEARCH_PARAM;

      if (requestMeta.search) {
        searchParams.append(searchParam, requestMeta.search);
      }

      const requestPath = searchParams.toString()
        ? `${requestMeta.resolvedPath}?${searchParams.toString()}`
        : requestMeta.resolvedPath;

      const response = await axiosPrivate.get<DropdownOptionsApiItem[]>(requestPath);
      const items = response.data.map((item) => ({
        id: String(item.id),
        name: item.name
      }));

      return {
        cacheKey: requestMeta.cacheKey,
        items
      } as FetchDropdownOptionsResult;
    } catch (error) {
      if (error instanceof Error) {
        return rejectWithValue(error.message);
      }

      return rejectWithValue('Unable to load dropdown options');
    }
  }
);
